interface NoWifiIconProps {
  size?: number
  className?: string
}

/**
 * No-WiFi / connection-lost illustration.
 * Uses `currentColor` so it adapts to parent text color / theme.
 */
export function NoWifiIcon({ size = 120, className }: NoWifiIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      {/* Soft background circle */}
      <circle cx="60" cy="60" r="56" fill="currentColor" fillOpacity="0.06" />
      <circle cx="60" cy="60" r="46" fill="currentColor" fillOpacity="0.04" />

      {/* WiFi arcs — outer, middle, inner */}
      <path
        d="M20 48 C 44 24, 76 24, 100 48"
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeOpacity="0.45"
      />
      <path
        d="M32 60 C 48 44, 72 44, 88 60"
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeOpacity="0.65"
      />
      <path
        d="M44 72 C 52 64, 68 64, 76 72"
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeOpacity="0.85"
      />

      {/* WiFi dot */}
      <circle cx="60" cy="84" r="4" fill="currentColor" />

      {/* Diagonal slash — strong stroke with contrasting outline */}
      <line
        x1="22"
        y1="22"
        x2="98"
        y2="98"
        stroke="#ffffff"
        strokeWidth="9"
        strokeLinecap="round"
      />
      <line
        x1="22"
        y1="22"
        x2="98"
        y2="98"
        stroke="#ef4444"
        strokeWidth="5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default NoWifiIcon
